// Prefer runtime config (injected by nginx) if available
let cfg = window.__APP_CONFIG__;

if (!cfg) {
    // Fallback for local dev with yarn serve
    cfg = {
        backendProtocol: process.env.VUE_APP_BACKEND_PROTOCOL || "http://",
        backendHost: process.env.VUE_APP_BACKEND_HOST || "localhost",
        backendPort: process.env.VUE_APP_BACKEND_PORT || ":9000",
        disableEslint: process.env.VUE_APP_DISABLE_ESLINT || false,
        nodeEnv: process.env.NODE_ENV || "development"
    };
}

export const API_BASE = `${cfg.backendProtocol}${cfg.backendHost}${cfg.backendPort}`;
console.log("API base domain: " + API_BASE);

export const backendProtocol = cfg.backendProtocol;
export const backendHost = cfg.backendHost;
export const backendPort = cfg.backendPort;